import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import GorbeaUserDetailsModal from './GorbeaUserDetailsModal';
import JokoakNavbar from '../aurrera-jokoak/JokoakNavbar';
import NagusiBackNav from '../common/NagusiBackNav';
import JokoakScoringCriteriaCard from '../aurrera-jokoak/JokoakScoringCriteriaCard';
export default class GorbeaClassificationPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasonParam", '');
    _defineProperty(this, "seasonId", 0);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "loadingMore", false);
    _defineProperty(this, "ranking", []);
    _defineProperty(this, "fechaCierre", null);
    // Pagination state
    _defineProperty(this, "offset", 0);
    _defineProperty(this, "limit", 50);
    _defineProperty(this, "hasMore", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.seasonParam = m.route.param('season') || '2025-2026';
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.offset = 0;
    const pSeasons = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    });
    const pClassification = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/gorbea-classification",
      params: {
        season: this.seasonParam,
        page: {
          limit: this.limit,
          offset: this.offset
        }
      }
    });
    Promise.all([pSeasons, pClassification]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        seasonsResp = _ref2[0],
        classResp = _ref2[1];
      const seasons = app.store.pushPayload(seasonsResp) || [];
      const currentSeason = seasons.find(s => s.name().replace('/', '-') === this.seasonParam);
      if (currentSeason) {
        const dateStr = currentSeason.attribute('fechaCierreVotacionesPastorGorbea');
        this.fechaCierre = dateStr ? new Date(dateStr) : null;
      } else {
        this.fechaCierre = null;
      }
      this.ranking = app.store.pushPayload(classResp) || [];
      const meta = classResp.meta || {};
      const totalCount = meta.totalCount || 0;
      this.hasMore = this.ranking.length < totalCount;
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      m.redraw();
    });
  }
  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    this.loadingMore = true;
    this.offset += this.limit;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/gorbea-classification",
      params: {
        season: this.seasonParam,
        page: {
          limit: this.limit,
          offset: this.offset
        }
      }
    }).then(response => {
      const nextResults = app.store.pushPayload(response) || [];
      this.ranking = [...this.ranking, ...nextResults];
      const meta = response.meta || {};
      const totalCount = meta.totalCount || 0;
      this.hasMore = this.ranking.length < totalCount;
      this.loadingMore = false;
      m.redraw();
    }).catch(() => {
      this.loadingMore = false;
      m.redraw();
    });
  }
  showUserDetails(entry) {
    app.modal.show(GorbeaUserDetailsModal, {
      entry,
      season: this.seasonParam
    });
  }
  scrollToUser(userId) {
    let el = document.getElementById("gorbea-user-row-".concat(userId));
    if (!el) {
      el = document.getElementById("gorbea-podium-user-".concat(userId));
    }
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      el.classList.remove('is-flashing');
      void el.offsetWidth;
      el.classList.add('is-flashing');
      setTimeout(() => {
        if (el) el.classList.remove('is-flashing');
      }, 2600);
    }
  }
  isVotacionCerrada() {
    return this.fechaCierre ? new Date() > this.fechaCierre : false;
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const season = this.seasonParam || '2025-2026';
    const isVoteMode = m.route.param('view') === 'pronosticar';
    const ranks = [];
    const ties = [];
    let currentRank = 1;
    for (let i = 0; i < this.ranking.length; i++) {
      if (i > 0 && this.ranking[i].totalScore() !== this.ranking[i - 1].totalScore()) {
        currentRank = i + 1;
      }
      ranks[i] = currentRank;
    }
    for (let i = 0; i < this.ranking.length; i++) {
      const r = ranks[i];
      ties[i] = ranks.filter(x => x === r).length > 1;
    }
    const top3 = this.ranking.slice(0, 3);
    const restOfPlayers = this.ranking.slice(3);
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaUrl = isReal ? 'pastor-del-txindoki' : 'pastor-del-gorbea';
    const gorbeaLabel = isReal ? 'Txindoki' : 'Gorbea';
    const teamName = isReal ? 'Real Sociedad' : 'Athletic Club';
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Pastor del ".concat(gorbeaLabel)
    }), m("h2", {
      className: "BolillaPage-Title"
    }, "Pastor del ", gorbeaLabel), m(JokoakNavbar, null), m("div", {
      className: "JokoakSubmenu"
    }, m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/clasificacion"),
      className: "JokoakSubmenu-link ".concat(!isVoteMode ? 'active' : '')
    }, "\uD83C\uDFC6 Clasificaci\xF3n"), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticar"),
      className: "JokoakSubmenu-link ".concat(isVoteMode ? 'active' : '')
    }, "\u26F0\uFE0F Pronosticar"), m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticos"),
      className: "JokoakSubmenu-link"
    }, "\uD83D\uDD2E Apuestas de foreros")), isVoteMode ? m("div", {
      style: "margin-top: 30px; text-align: center; background: #fff; padding: 40px; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 20px rgba(0,0,0,0.04);"
    }, m("span", {
      style: "font-size: 3em;"
    }, "\u26F0\uFE0F"), m("h3", {
      style: "font-weight: 800; margin-top: 15px;"
    }, "Pron\xF3sticos del Pastor del ", gorbeaLabel), m("p", {
      style: "color: #666; max-width: 500px; margin: 0 auto 25px auto;"
    }, this.isVotacionCerrada() ? 'El plazo para realizar o editar tus pronósticos de la temporada ha finalizado.' : 'Elige tus pronósticos de la temporada antes de que comience la competición oficial.'), !this.isVotacionCerrada() && m(Link, {
      href: "/".concat(gorbeaUrl, "/").concat(season, "/pronosticar"),
      className: "Button Button--primary",
      style: "border-radius: 20px; font-weight: bold; padding: 8px 24px;"
    }, "\u26F0\uFE0F Realizar Pron\xF3stico")) : m("div", null, m(JokoakScoringCriteriaCard, {
      game: "gorbea",
      teamName: teamName
    }), top3.length > 0 && m("div", {
      className: "SeasonOverview"
    }, m("div", {
      className: "Podium"
    }, top3[1] && this.renderPodiumUser(top3[1], ranks[1]), top3[0] && this.renderPodiumUser(top3[0], ranks[0]), top3[2] && this.renderPodiumUser(top3[2], ranks[2]))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics",
      style: "width: 100%;"
    }, m("div", {
      className: "Top-Players-Full-Table"
    }, m("div", {
      className: "Classification-Header-Actions"
    }, m("h4", {
      style: "font-weight: 800; font-size: 1.25em; margin: 0;"
    }, "Clasificaci\xF3n de Foreros"), (() => {
      const currentUserId = app.session.user ? app.session.user.id() : null;
      if (!currentUserId) return null;
      const userRankIndex = this.ranking.findIndex(entry => entry.user() && String(entry.user().id()) === String(currentUserId));
      if (userRankIndex === -1) return null;
      const myRank = ranks[userRankIndex];
      return m(Button, {
        className: "Button Button--my-position",
        onclick: () => this.scrollToUser(currentUserId),
        icon: "fas fa-crosshairs"
      }, m("span", null, "Mi posici\xF3n (", myRank, "\xBA)"));
    })()), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, "Usuario"), m("th", {
      className: "center"
    }, "Puntos"), m("th", {
      className: "center"
    }, "Detalles"))), m("tbody", null, this.ranking.map((entry, index) => {
      const user = entry.user();
      if (!user) return null;
      const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
      const userUrl = app.route('user', {
        username: user.slug()
      });
      const rank = ranks[index];
      return m("tr", {
        key: user.id(),
        id: "gorbea-user-row-".concat(user.id()),
        className: isCurrent ? 'highlight-current-user' : ''
      }, m("td", null, m("div", {
        className: "Player-Table-Info",
        style: "display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        className: "rank-badge-cell"
      }, m("span", {
        className: "rank-badge rank-".concat(rank)
      }, rank, "\xBA")), m(Link, {
        href: userUrl
      }, avatar(user, {
        className: 'Player-Avatar-Tiny'
      })), m(Link, {
        href: userUrl,
        className: "Player-Name",
        style: "font-weight: bold; text-decoration: none;"
      }, username(user)), isCurrent && m("span", {
        className: "badge-you"
      }, "T\xDA"))), m("td", {
        className: "center bold",
        style: "font-size: 1.15em; color: #EE2523;"
      }, entry.totalScore()), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => this.showUserDetails(entry),
        icon: "fas fa-info-circle"
      }, m("span", {
        className: "Button-label"
      }, "Ver Desglose"))));
    })))), this.hasMore && m("div", {
      style: "text-align: center; margin-top: 20px;"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.loadingMore,
      onclick: () => this.loadMore(),
      style: "border-radius: 20px; padding: 8px 24px; font-weight: bold;"
    }, "Cargar m\xE1s participantes"))))))));
  }
  renderPodiumUser(entry, position) {
    const user = entry.user();
    if (!user) return null;
    const isFirst = position === 1;
    const isCurrent = app.session.user && String(app.session.user.id()) === String(user.id());
    const userUrl = app.route('user', {
      username: user.slug()
    });
    const pathId = 'txapela-podium-path-' + Math.random().toString(36).substr(2, 9);
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const isReal = clubSlug === 'real-sociedad';
    const gorbeaLabel = isReal ? 'Txindoki' : 'Gorbea';
    return m("div", {
      id: "gorbea-podium-user-".concat(user.id()),
      className: "Podium-Player pos-".concat(position, " ").concat(isFirst ? 'MVP' : '', " ").concat(isCurrent ? 'highlight-current-user' : '')
    }, m(Link, {
      href: userUrl,
      className: "Player-Avatar-Wrapper"
    }, avatar(user), m("div", {
      className: "Rank-Badge"
    }, position), isFirst && m("div", {
      className: "MVP-Txapela"
    }, m("svg", {
      viewBox: "0 0 100 45",
      className: "txapela-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, m("defs", null, m("path", {
      id: pathId,
      d: "M 8,24 Q 50,13 92,24",
      fill: "none",
      stroke: "none"
    })), m("ellipse", {
      cx: "50",
      cy: "30",
      rx: "35",
      ry: "8",
      fill: "rgba(0, 0, 0, 0.25)"
    }), m("path", {
      d: "M 8,24 C 8,6 92,6 92,24 C 92,36 8,36 8,24 Z",
      fill: "#2e4d28"
    }), " ", m("path", {
      d: "M 20,28 Q 50,34 80,28 Q 50,23 20,28 Z",
      fill: "#131314"
    }), m("path", {
      d: "M 50,11 Q 50,4 51,2 Q 53,4 53,11 Z",
      fill: "#2e4d28"
    }), m("text", {
      fill: "#ffffff",
      "font-size": "4.5",
      "font-weight": "900",
      "letter-spacing": "0.7",
      stroke: "#2e4d28",
      "stroke-width": "0.1px",
      dy: "1.5",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, m("textPath", {
      href: "#".concat(pathId),
      startOffset: "50%",
      "text-anchor": "middle",
      textAnchor: "middle"
    }, "PASTOR ", gorbeaLabel.toUpperCase()))))), m("div", {
      className: "Player-Details"
    }, m(Link, {
      href: userUrl,
      className: "Player-Name"
    }, username(user), isCurrent && m("span", {
      className: "badge-you"
    }, "T\xDA")), m("div", {
      className: "Player-Score-Container"
    }, m("span", {
      className: "Player-Average"
    }, entry.totalScore()), m("span", {
      className: "Label"
    }, "puntos"))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaClassificationPage', GorbeaClassificationPage);